//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["rules", "ruleCtrl", "selectedRule"],
  data: function () {
    return {
      slotSelectedRule: null,
    };
  },
  created: function () {
    this.slotSelectedRule = this.selectedRule;
  },
  computed: {
    ruleName() {
      if (!this.slotSelectedRule) {
        return this.rules.find((r) => r.identifier === this.$parent.query.identifier)
          .name;
      }
      return this.rules.find((r) => r.identifier === this.slotSelectedRule)
        .name;
    },
  },
  watch: {
    '$parent.query.identifier': {
      immediate: true,
      handler: function () {
        this.slotSelectedRule = this.$parent.query.identifier;
      },
    },
  },
};
